//@ts-check

// Correction to remove the gap above the first line when the line height is big.

import debug from "debug";

const log = debug("type-tester:line-height-gap-correction");

/**
 *
 * @param {HTMLElement} editorElement
 * @param {{top: number, bottom: number}} lineHeightGapCorrections
 */
export function applyLineHeightGapCorrection(
  editorElement,
  lineHeightGapCorrections
) {
  const renderedTextElement = editorElement.parentElement;

  const { top, bottom } = lineHeightGapCorrections;

  log(`applying ${top} ${bottom}`);

  renderedTextElement.style.setProperty(
    "--line-height-gap-top-correction",
    `${top}px`
  );
  renderedTextElement.style.setProperty(
    "--line-height-gap-bottom-correction",
    `${bottom}px`
  );
}

/**
 *
 * Called from font-scaler.js
 *
 * @param {import("../types").TypeTesterFontSettings} fontSettings
 * @param {{lineHeightPercent: number, fontSize: number, columns: number, browser: {isSafari: boolean}}} options
 * @returns {{top: number, bottom: number}}
 */
export function determineLineHeightGapCorrection(fontSettings, options) {
  const { lineHeightPercent, fontSize, columns, browser } = options;
  const { isSafari } = browser;

  const isSafariMulticolumn = isSafari && (columns ?? 1) > 1;

  const calcOneSide = (lineHeightThreshold) => {
    // Safari in multicolumn mode, the top gap does not increase while the line height is below safariLhBalanceMinLineHeight
    if (isSafariMulticolumn && lineHeightPercent <= lineHeightThreshold)
      return 0;

    const correctionUnscaled = (lineHeightThreshold - lineHeightPercent) / 2;
    const correctionScaled = (correctionUnscaled * fontSize) / 100;
    return correctionScaled;
  };

  // Threshold too low => the top line moves down as the line height approaches the lower limit
  // Threshold too high => the top line moves dows as the line height goes up
  const top = calcOneSide(
    isSafariMulticolumn
      ? fontSettings.safariLhBalanceMinLineHeight
      : fontSettings.minLineHeightAscender
  );
  const bottom = calcOneSide(fontSettings.minLineHeightDescender);

  return {
    top,
    bottom,
  };
}
